// A feed row that swipes on phones: left archives, right snoozes until later today. Only cards
// waiting for review swipe; everywhere else (and on wider screens) it is the plain row.
import type { ComponentProps } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { CardRow } from "@web/feed/BoardParts";
import { isToReview } from "@web/feed/selectors";
import { SwipeRow, usePhone } from "./SwipeRow";
import { SWIPE_SNOOZE, swipeArchive, swipeSnooze } from "./swipeOps";

export function SwipeableCardRow(props: ComponentProps<typeof CardRow>) {
  const queryClient = useQueryClient();
  const phone = usePhone();
  const { card } = props;
  const enabled = phone && isToReview(card) && !card.work;
  if (!enabled) return <CardRow {...props} />;
  return (
    <SwipeRow
      enabled
      onArchive={card.threadKey ? () => void swipeArchive(queryClient, card) : null}
      onSnooze={() => void swipeSnooze(queryClient, card)}
      snoozeLabel={SWIPE_SNOOZE.label}
    >
      <CardRow {...props} />
    </SwipeRow>
  );
}
